/*
 * Copyright © 2016-2018 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/*@ngInject*/
export default function ResetPasswordController($stateParams, $translate, toast, loginService, userService, $window, $location) {
    var vm = this;

    vm.newPassword = '';
    vm.newPassword2 = '';

    vm.resetPassword = resetPassword;

    function resetPassword() {
        if (vm.newPassword !== vm.newPassword2) {
            toast.showError($translate.instant('login.passwords-mismatch-error'));
        } else {
            loginService.resetPassword($stateParams.resetToken, vm.newPassword).then(function success(response) {
                var token = response.data.token;
                var refreshToken = response.data.refreshToken;
                if ($location.search().callback) {
                    $window.location = $location.search().callback;
                }else{
                    userService.setUserFromJwtToken(token, refreshToken, true);
                }
            }, function fail() {
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/login/reset-password.controller.js